import React from 'react';

import { CARD_THEMES } from './card_theme';
import { IndexCard, getIndexCards } from './index_card';
import { LinkCard, getCardPaths } from './link_card';

import type { LinkCardRecord } from './link_card';
import type { PropertyToolCall } from '../types';

interface PropertyCard extends LinkCardRecord {
  address: string | null;
  displayName: string | null;
}

interface PropertyCardsProps {
  toolCalls: PropertyToolCall[];
}

export function PropertyCards({ toolCalls }: PropertyCardsProps) {
  return (
    <>
      {getCardPaths(toolCalls).map(path => (
        <LinkCard key={path} path={path} theme={CARD_THEMES.property}>
          {(property: PropertyCard) => (
            <>
              <div className="fw-semibold text-truncate">{property.displayName}</div>
              {property.address && <div className="small text-muted text-truncate">{property.address}</div>}
            </>
          )}
        </LinkCard>
      ))}
      {getIndexCards(toolCalls).map(index => (
        <IndexCard
          index={index}
          key={index.path}
          label="properties"
          pageName="Properties"
          theme={CARD_THEMES.property}
        />
      ))}
    </>
  );
}
